<template >
  <div class="ma-0 pa-0">
    <!-- templates.nav-bar.params.hide-logo="true"
      templates.nav-bar.params.hide-hd="false"
      templates.nav-bar.params.hide-vr="false" 
      templates.nav-bar.params.disable-on-fullscreen="true"
      -->
    <!-- <babylon
      id="loading-demo"
      :model="fileDetail.fileglb"
      templates.main.params.fill-screen="true"
      templates.viewer.params.enable-drag-and-drop="true"
      templates.nav-bar.html="<div/>"
      templates.loading-screen.params.background-color="#c3c3c3"
      templates.loading-screen.params.loading-image="null"
      templates.loading-screen.params.static-loading-image="/static/assets/final_gif.gif"
      camera.behaviors.auto-rotate="0"
      skybox="false"
      ground="false"
    >
    </babylon> -->
    <div class="ma-0 pa-0">
      <babylon
        :style="cssVars"
        class="ma-0 pa-0"
        id="loading-demo"
        :model="fileDetail.fileglb"
        templates.main.params.fill-screen="true"
        templates.viewer.params.enable-drag-and-drop="true"
        templates.nav-bar.html="<div/>"
        templates.loading-screen.params.background-color="#c3c3c3"
        templates.loading-screen.params.loading-image="null"
        templates.loading-screen.params.static-loading-image="/static/assets/final_gif.gif"
        camera.behaviors.auto-rotate="0"
        skybox="false"
        ground="false"
      >
      </babylon>
    </div>
    <!-- <model :url="fileDetail.fileglb"> </model> -->
    <!-- <scene disable-camera-control="true"> </scene> -->

    <!-- <div
      style="width: 100%; height: 100%; padding: 0; margin: 0"
      id="hostBabylon"
    ></div> -->
    <!-- <div class="zipPopupBack">
      <v-card
        width="320"
        height="180"
        style="
          border-radius: 15px;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 10000000000;
        "
        elevation="6"
      >
        <div class="drop-zone">
          <v-btn
            v-if="augmentableTheme"
            class="drop-zone__prompt"
            @click="inputFileClick()"
            icon
          >
            <md-icon
              class="md-size-3x"
              md-src="/static/assets/svg/white/Upload.svg"
            ></md-icon>
          </v-btn>

          <v-btn
            v-if="!augmentableTheme"
            class="drop-zone__prompt"
            @click="inputFileClick()"
            icon
          >
            <md-icon
              class="md-size-3x"
              md-src="/static/assets/svg/black/Upload.svg"
            ></md-icon>
          </v-btn>

          <input
            type="file"
            name="ARfile"
            id="rr1"
            @change="changeScene()"
            class="drop-zone__input"
          />
        </div>
      </v-card>
    </div> -->

    <div
      style="
        position: absolute;
        left: 0.5%;
        top: 1.5%;
        z-index: 100000000;
        display: flex;
      "
    >
      <div class="ma-0 pa-0">
        <v-btn icon>
          <v-icon v-if="editorSidebar" @click="toggleSidebar()">
            mdi-dots-vertical
          </v-icon>
          <v-icon v-if="!editorSidebar" @click="toggleSidebar()">
            mdi-dots-vertical
          </v-icon>
        </v-btn>
      </div>
      <!-- <div class="ma-0 pa-0 mt-n3">
        <v-switch
          dense
          v-model="backgroundProcess"
          :label="`Drop Zip: ${backgroundProcess.toString()}`"
        ></v-switch>
      </div> -->
    </div>

    <div
      id="inspectorDiv"
      style="
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1000000;
        height: 100%;
      "
    ></div>
    <!-- <div style="position: absolute; right: 20px; top: 30px">
      <p>
        Width: <span>{{ $vssWidth }}</span>
      </p>
      <p>
        Height: <span>{{ screenWidth }}</span>
      </p>
    </div> -->
    <v-overlay :value="overlayP">
      <v-progress-circular v-bind="spinnerProps"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import * as BabylonViewer from "@babylonjs/viewer";
import { GLTF2Export } from "@babylonjs/serializers/glTF";

import store from "../store";
import { mapState } from "vuex";

import "@babylonjs/loaders/glTF";

import { Tools } from "@babylonjs/core/Misc";

import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import * as BABYLON from "@babylonjs/core";

//import VueScreenSize from "vue-screen-size";

// var cameraX;
// var cameraY;
// var cameraZ;

export default {
  name: "editor",
  components: {},

  //mixins: [VueScreenSize.VueScreenSizeMixin],

  data: function () {
    return {
      c: "",
      editorDiv: false,
      fileDetail: "",
      down: "true",
      overlayP: false,
      sideBar: false,
      cameraX: "",
      cameraY: "",
      cameraZ: "",
      backgroundProcess: false,
      file: "",
      fileName: "",
      extention: "",

      spinnerProps: {
        color: "primary",
        value: 100,
        indeterminate: true,
        size: 80,
      },
    };
  },
  watch: {
    backgroundProcess: function (val) {
      console.log(val);
    },
  },
  computed: {
    ...mapState(["augmentableTheme"]),
    ...mapState(["editorSidebar"]),
    cssVars() {
      return {
        /* variables you want to pass to css */
        "--width": (this.$vssWidth + "px").replace(/^"(.+(?="$))"$/, "$1"),
      };
    },
    screenWidth() {
      return (this.$vssWidth + "px").replace(/^"(.+(?="$))"$/, "$1");
    },
  },
  created() {
    // window.onbeforeunload = function () {
    //   return "handle your events or msgs here";
    // };
    // window.addEventListener("beforeunload", (event) => {
    //   // Cancel the event as stated by the standard.
    //   event.preventDefault();
    //   alert("hhh");
    //   // Chrome requires returnValue to be set.
    //   event.returnValue = "";
    // });
    //window.addEventListener("beforeunload", this.leaving());
  },

  // beforeMount() {
  //   window.addEventListener("beforeunload", this.leaving());
  // },

  // beforeDestroy() {
  //   window.removeEventListener("beforeunload", this.leaving());
  // },

  mounted() {
    if (localStorage.getItem("reloaded")) {
      // The page was just reloaded. Clear the value from local storage
      // so that it will reload the next time this page is visited.
      localStorage.removeItem("reloaded");
    } else {
      // Set a flag so that we know not to reload the page twice.
      localStorage.setItem("reloaded", "1");
      this.$router.go();
    }

    document.querySelectorAll(".drop-zone__input").forEach((inputElement) => {
      const dropZoneElement = inputElement.closest(".drop-zone");
      dropZoneElement.addEventListener("dragover", (e) => {
        e.preventDefault();
        //dropZoneElement.classList.add("drop-zone--over");
      });
      ["dragleave", "dragend"].forEach((type) => {
        dropZoneElement.addEventListener(type, (e) => {
          console.log(e);
          //dropZoneElement.classList.remove("drop-zone--over");
        });
      });
      dropZoneElement.addEventListener("drop", (e) => {
        e.preventDefault();
        if (e.dataTransfer.files.length) {
          inputElement.files = e.dataTransfer.files;
          this.updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
        }

        //dropZoneElement.classList.remove("drop-zone--over");
      });
    });

    //sandbox
    // let host = document.getElementById("hostBabylon");
    // BABYLON.Sandbox.Show(host);
    //sandbox

    //added lately to make it false (to cover right blank space)
    this.$store.commit("setEditorSidebar", false);
    //added lately

    this.sideBar = this.$sidebar.showSidebar;

    this.fileDetail = store.state.fileDetail;

    // BabylonViewer.viewerManager
    //   .getViewerPromiseById("loading-demo")
    //   .then(function (viewer) {
    //     // this will resolve only after the viewer with this specific ID is initialized
    //     viewer.onEngineInitObservable.add(function (scene) {
    //       viewer.loadModel({
    //         loader: ".gltf",
    //       });
    //       console.log(scene);
    //     });
    //   });

    //     class MyAwesomeButton extends BabylonViewer.AbstractViewerNavbarButton {
    //       constructor(viewer) {
    //         super();
    //         this.viewer = viewer;
    //         this._buttonClass = "test-button";
    //         this._htmlTemplate = `
    // <button class="test-button">
    // <span class="icon" style="background: gray; display: inline-block">
    //    <svg viewBox="0 0 16 16">
    //   <use xlink:href="/static/assets/svg/editorOpen.svg"></use>
    // </svg>
    //  </button>
    // `;
    //         // optional - which events to you want to attach to:
    //         this.eventsToAttach.push("pointerup");
    //       }
    //     }
    //     BabylonViewer.viewerManager
    //       .getViewerPromiseById("loading-demo")
    //       .then(function (viewer) {
    //         viewer.onInitDoneObservable.add(function () {
    //           viewer.registerTemplatePlugin(new MyAwesomeButton(viewer));
    //         });
    //       });
  },
  methods: {
    updateThumbnail(dropZoneElement, file) {
      //let thumbnailElement = dropZoneElement.querySelector(".drop-zone__thumb");

      console.log(dropZoneElement);
      console.log(file);

      this.fileName = file.name;
      console.log(this.fileName);
      this.fileName = this.fileName.replace(/\.[^/.]+$/, "");
      console.log(this.fileName);

      this.extention = file.name.split(".").pop();
      console.log(this.extention);
      console.log(file.name);

      if (this.extention === "zip") {
        console.log(this.extention);

        //file upload to server
        this.file = file;
        this.fileName = file.name;

        let formData = new FormData();
        formData.append("file_glb", this.file);
        formData.append("file_name", file.name);
        formData.append("file_type", this.extention);
      }
    },
    DelayPromise(delay) {
      //return a function that accepts a single variable
      return function (data) {
        //this function returns a promise.
        return new Promise(function (resolve, reject) {
          console.log(reject);
          setTimeout(function () {
            //a promise that is resolved after "delay" milliseconds with the data provided
            console.log("done!");
            resolve(data);
          }, delay);
        });
      };
    },

    async getToFile() {
      this.overlayP = true;
      var router = this.$router;
      var abServerPath = this.$abServerPath;
      let filepng = await fetch(this.fileDetail.filepng)
        .then((r) => r.blob())
        .then(
          //(blobFile) => new File([blobFile], this.fileDetail.filename + ".png")
          (blobFile) => new Blob([blobFile], { type: "image/png" })
        );
      console.log(filepng);

      this.down = "false";

      var selectedFileVersion = this.fileDetail.filename;
      console.log(selectedFileVersion);

      var authToken = this.getAuthCookie("augmentableUserToken");
      console.log(authToken);

      let formData = new FormData();

      // formData.append(
      //   "fileglb",
      //   this.file,
      //   this.fileName + "." + this.extention.toLowerCase()
      // );
      //formData.append("filepng", this.imageBlob, this.fileName + ".png");
      formData.append("filename", this.fileDetail.filename);
      formData.append("filetype", "GLB");
      //this should be improved
      // formData.append("filepng", filepng, this.fileDetail.filename + ".png");
      //this should be improved

      formData.append("description", "");
      formData.append("state", "unProcessed");
      formData.append("tags", "");
      formData.append("linkHDR", "");

      var tt = this.fileDetail.filename + ".glb";

      //solution for scope
      //let _this = this;

      BabylonViewer.viewerManager
        .getViewerPromiseById("loading-demo")
        .then(function (viewer) {
          //viewer.sceneManager.scene.getMeshByName("hdrSkyBox").dispose();
          // let tt = viewer.sceneManager.scene.createDefaultEnvironment();
          // tt.skybox.dispose();
          // tt.ground.dispose();

          //viewer.sceneManager.scene.environmentTexture.dispose();
          // viewer.sceneManager.scene.environmentTexture = null;

          // this will resolve only after the viewer with this specific ID is initialized

          // GLTF2Export.GLTFAsync(viewer.sceneManager.scene, "fileName").then(
          //   (gltf) => {
          //     gltf.downloadFiles();
          //   }
          // );

          // GLTF2Export.GLBAsync(viewer.sceneManager.ImportMesh, "fileName").then(
          //   (glb) => {
          //     glb.downloadFiles();
          //   }
          // );

          // let skybox = viewer.sceneManager.scene.createDefaultSkybox();
          // let options = {
          //   shouldExportNode: function (node) {
          //     return node !== skybox;
          //   },
          // };
          // GLTF2Export.GLBAsync(
          //   viewer.sceneManager.scene,
          //   "scene",
          //   options
          // ).then((glb) => {
          //   glb.downloadFiles();
          //   this.down = true;
          // });

          // var hdrTexture = new BABYLON.CubeTexture(
          //   "/static/assets/images/abandoned_hall_01_4k.hdr",
          //   viewer.sceneManager.scene
          // );

          // // Initializer code...
          // let skybox = viewer.sceneManager.scene.createDefaultSkybox(
          //   hdrTexture,
          //   true,
          //   100,
          //   0.3
          // );
          // // scene setup code...
          // let options = {
          //   shouldExportNode: function (node) {
          //     return node !== skybox;
          //   },
          // };
          //CreateScreenshot(engine, camera,{ width: 600, height: 400})

          //to make the scene transparent
          viewer.sceneManager.scene.clearColor = new BABYLON.Color4(
            0,
            0,
            0,
            0.0000000000000001
          );

          let activeCamera = viewer.sceneManager.scene.activeCamera;
          //change Active Camera to
          // var camera2 = new BABYLON.FreeCamera(
          //   "camera2",
          //   new BABYLON.Vector3(0, 0, 0),
          //   viewer.sceneManager.scene
          // );
          // camera2.setTarget(BABYLON.Vector3.Zero());
          // let activeCamera = camera2;
          //activeCamera.setTarget(BABYLON.Vector3(0, 0, 0));
          // console.log(cameraX + "");
          // console.log("emmmm");
          // activeCamera.position = new BABYLON.Vector3(
          //   cameraX,
          //   cameraY,
          //   cameraZ
          // );
          if (activeCamera) {
            Tools.CreateScreenshotUsingRenderTarget(
              viewer.sceneManager.scene.getEngine(),
              activeCamera,
              { width: 490, height: 490 },
              function (data) {
                console.log(data);
                //var blob = this.dataURItoBlob(data);

                // var binaryVal;
                // // mime extension extraction
                // var inputMIME = data.split(",")[0].split(":")[1].split(";")[0];

                // // Extract remaining part of URL and convert it to binary value
                // if (data.split(",")[0].indexOf("base64") >= 0)
                //   binaryVal = atob(data.split(",")[1]);
                // // Decoding of base64 encoded string
                // else binaryVal = unescape(data.split(",")[1]);

                // // Computation of new string in which hexadecimal
                // // escape sequences are replaced by the character
                // // it represents

                // // Store the bytes of the string to a typed array
                // var blobArray = [];
                // for (var index = 0; index < binaryVal.length; index++) {
                //   blobArray.push(binaryVal.charCodeAt(index));
                // }
                // var blob = new Blob([blobArray], {
                //   type: inputMIME,
                // });

                var byteString;
                if (data.split(",")[0].indexOf("base64") >= 0)
                  byteString = atob(data.split(",")[1]);
                else byteString = unescape(data.split(",")[1]);

                // separate out the mime component
                var mimeString = data.split(",")[0].split(":")[1].split(";")[0];

                // write the bytes of the string to a typed array
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                  ia[i] = byteString.charCodeAt(i);
                }

                var blob = new Blob([ia], { type: mimeString });

                formData.append("filepng", blob, selectedFileVersion + ".png");

                //var arr = convertDataURIToBinaryBuffer(data);
                //window.open(data, "_blank");
                //var blob = new Blob([arr], { type: "image/png" });
                // const a = document.createElement("a");
                // a.href = URL.createObjectURL(blob);
                // a.download = "screenshot";
                // a.click();
              }
            );
          }

          // if (viewer.sceneManager.scene.getEngine()) {
          //   console.log(viewer.sceneManager.scene.getEngine());
          // }
          //viewer.sceneManager.scene.createDefaultSkybox();

          GLTF2Export.GLBAsync(viewer.sceneManager.scene, "scene").then(
            (glb) => {
              console.log(glb.glTFFiles["scene.glb"]);
              var file = new File([glb.glTFFiles["scene.glb"]], "export.glb");

              formData.append("fileglb", file, tt);
              console.log(file);
              //console.log("" + (file.size / (1024 * 1024)).toFixed(2) + "MB");
              var filesize = "" + (file.size / (1024 * 1024)).toFixed(2) + "MB";
              formData.append("filesize", filesize);

              console.log(formData);
              // var link = document.createElement("a");
              // link.download = file.name;
              // link.href = URL.createObjectURL(file);
              // link.click();
              //console.log(file.name);
              //glb.downloadFiles();

              axios
                .post(
                  abServerPath +
                    "/api/glbfiles/glbpostfileversion/" +
                    selectedFileVersion +
                    "/",
                  formData,
                  {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      Authorization: "Token " + authToken + "",
                    },
                  }
                )
                .then((response) => {
                  router.push({
                    name: "File Detail",
                    params: { slug: store.state.fileDetail.slug },
                  });
                  console.log(response.data);
                  console.log("SUCCESS!!");
                })
                .catch((error) => {
                  router.push({
                    name: "File Detail",
                    params: { slug: store.state.fileDetail.slug },
                  });
                  console.log(error.data);
                  console.log("ffff");
                });
            }
          );
        });
    },
    autolod() {
      alert("AUTOLOD Begins !");
      BabylonViewer.viewerManager
        .getViewerPromiseById("loading-demo")
        .then(function (viewer) {
          console.log(viewer.sceneManager.scene);
          console.log(viewer.sceneManager.scene.materials);
          console.log(viewer.sceneManager.scene.meshes);
          var len = viewer.sceneManager.scene.meshes.length;
          for (var i = 2; i < len; i++) {
            var m = viewer.sceneManager.scene.meshes[i];
            m.optimizeIndices(function () {
              //console.log("agaya");
              m.simplify(
                [
                  { distance: 5, quality: 0.5 },
                  { distance: 2, quality: 0.9 },
                ],
                false,
                BABYLON.SimplificationType.QUADRATIC,
                function () {
                  console.log("YES !!!!");
                  // console.log(viewer.sceneManager.scene);
                  // console.log(viewer.sceneManager.scene.materials);
                  // console.log(viewer.sceneManager.scene.materials);
                  // console.log(viewer.sceneManager.scene.meshes);
                  // //viewer.sceneManager.scene.materials.splice(2,6);
                  // console.log(viewer.sceneManager.scene.meshes);
                }
              );
            });
            // m = viewer.sceneManager.scene.meshes[8];
            // m.optimizeIndices(function(){
            // //console.log("agaya");
            // m.simplify(
            //     [
            //         { distance: 1, quality: 0.8 }
            //     ],
            //     false,
            //     BABYLON.SimplificationType.QUADRATIC,
            //     function () {
            //         console.log("YES !!!!");
            //         console.log(viewer.sceneManager.scene);
            //         console.log(viewer.sceneManager.scene.materials);
            //         console.log(viewer.sceneManager.scene.materials);
            //         console.log(viewer.sceneManager.scene.meshes);

            //         console.log(viewer.sceneManager.scene.meshes);

            //     }
            // );

            //  });
            //    viewer.sceneManager.scene.meshes.splice(3,1);
            //    viewer.sceneManager.scene.meshes.splice(7,1);
          } //loop bracket
        });
    },
    getLOD() {
      BabylonViewer.viewerManager
        .getViewerPromiseById("loading-demo")
        .then(function (viewer) {
          var newMeshes = viewer.sceneManager.scene.meshes;
          console.log(newMeshes);

          var decimator = new BABYLON.QuadraticErrorSimplification(newMeshes);

          console.log(decimator);

          decimator.simplify(
            [{ distance: 150, quality: 0.5, aggressiveness: 1 }],
            false,
            BABYLON.SimplificationType.QUADRATIC,
            function () {
              console.log("simplification ended: ", new Date().getTime());
            }
          );

          // newMeshes.simplify(
          //   [
          //     { quality: 0.9, distance: 25 },
          //     { quality: 0.3, distance: 50 },
          //   ],
          //   false,
          //   BABYLON.SimplificationType.QUADRATIC,
          //   function () {
          //     alert("LOD finisehd, let's have a beer!");
          //   }
          // );
          console.log("tyuytu");
          console.log(newMeshes);
        });
    },
    // shouldExport(node: Node): boolean {

    //     // No skybox
    //     if (node instanceof Mesh) {
    //         if (node.material) {
    //             const material = node.material as PBRMaterial | StandardMaterial | BackgroundMaterial;
    //             const reflectionTexture = material.reflectionTexture;
    //             if (reflectionTexture && reflectionTexture.coordinatesMode === Texture.SKYBOX_MODE) {
    //                 return false;
    //             }
    //         }
    //     }

    //     return true;
    // },
    leaving() {
      alert("Leaving");
    },
    seeAction() {
      this.editorDiv = !this.editorDiv;
      if (this.editorDiv === true) {
        BabylonViewer.viewerManager
          .getViewerPromiseById("loading-demo")
          .then(function (viewer) {
            // this will resolve only after the viewer with this specific ID is initialized
            //console.log("Using promises: ", "viewer - " + viewer.getBaseId());
            //viewer.sceneManager.scene.debugLayer.show();

            viewer.sceneManager.scene.debugLayer.show({
              overlay: false,
              globalRoot: document.getElementById("inspectorDiv"),
              embedMode: true,
            });
          });
      } else {
        BabylonViewer.viewerManager
          .getViewerPromiseById("loading-demo")
          .then(function (viewer) {
            // this will resolve only after the viewer with this specific ID is initialized
            viewer.sceneManager.scene.debugLayer.hide();
          });
      }

      //BABYLON.Sandbox.Show({hostElement: document.getElementById("hhgg")});
    },
    getfileUrl() {
      return this.fileDetail.fileglb;
    },
    goToAssets() {
      this.$router.push({ path: "/assets" });
    },
    goToViewer() {
      this.$router.push({ path: "/viewer" });
    },
    async addFileRoute() {
      this.overlayP = true;
      var router = this.$router;

      BabylonViewer.viewerManager
        .getViewerPromiseById("loading-demo")
        .then(function (viewer) {
          viewer.sceneManager.scene.clearColor = new BABYLON.Color4(
            0,
            0,
            0,
            0.0000000000000001
          );

          GLTF2Export.GLBAsync(viewer.sceneManager.scene, "scene").then(
            (glb) => {
              console.log(glb.glTFFiles["scene.glb"]);
              var file = new File([glb.glTFFiles["scene.glb"]], "export.glb");
              //console.log(file);
              var batch = true;
              //var edi = true;
              router.push({
                name: "Add Asset",
                params: { batchFile: file, batch: batch },
              });
            }
          );
        });
    },
    seeAction1() {
      // this.$refs.file12.click();
      // const fileSelector = document.getElementById("fileInput");
      // fileSelector.addEventListener("change", (event) => {
      //   const fileList = event.target.files;
      //   console.log(fileList);
      //   this.file = event.target.files[0];
      //   console.log(this.file);
      //   BabylonViewer.viewerManager
      //     .getViewerPromiseById("babylon-viewer")
      //     .then(function (viewer) {
      //       // this will resolve only after the viewer with this specific ID is initialized
      //       viewer.onEngineInitObservable.add(function (scene) {
      //         viewer.loadModel({
      //           title: "Helmet",
      //           subtitle: "BabylonJS",
      //           thumbnail: null,
      //           url: URL.createObjectURL(this.file),
      //         });
      //         console.log(scene);
      //       });
      //     });
      //     });
      // let domElement = document.getElementById("loading-demo");
      // let viewer = new BabylonViewer.DefaultViewer(domElement, {
      //   scene: {
      //     debug: true,
      //   },
      //   camera: {
      //     behaviors: {
      //       autoRotate: 0,
      //     },
      //   },
      //   model: {
      //     url: URL.createObjectURL(this.file),
      //   },
      // });
      //   document.appendChild(viewer);
      // BabylonViewer.viewerManager
      //   .getViewerPromiseById("loading-demo")
      //   .then(function (viewer) {
      //     // this will resolve only after the viewer with this specific ID is initialized
      //     var tt = "hkjh";
      //     console.log(tt);
      //     viewer
      //       .loadModel({
      //         title: "Helmet",
      //         subtitle: "BabylonJS",
      //         thumbnail: null,
      //         url: URL.createObjectURL(this.file),
      //       })
      //       .then((model) => {
      //         console.log("model loaded!", model);
      //       })
      //       .catch((error) => {
      //         console.log("error loading the model!", error);
      //       });
      //   });
    },
    dataURItoBlob(dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    toggleSidebar() {
      //var x = !this.editorSidebar;
      this.$store.commit("setEditorSidebar", !this.editorSidebar);
      // this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      // this.sideBar = this.$sidebar.showSidebar;
      // console.log(this.$sidebar.showSidebar);
    },
  },
};
</script>

<style lang="scss" scoped>
// babylon {
//   width: 100%;
//   height: 100vh;
//   padding: 0;
//   margin: 0;
//   overflow: hidden;
// }

babylon {
  //width: var(--width);
  //all: unset !important;
  width: 100% !important;
  //max-width: 100vw !important;
  //max-width: 1980px !important;
  //height: 1050px !important;
  //width: 100vw !important;
  //min-width: 100vw !important;
  height: 100vh !important;
  //padding-top: 100%;
  padding: 0 !important;
  margin: 0 !important;
  //margin: 0 auto;
}

.drop-zone {
  width: 100%;

  min-height: 20vh;
  cursor: pointer;
}

.drop-zone--over {
  border-style: solid;
}

.drop-zone__input {
  display: none;
}

.drop-zone__thumb {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
}

.drop-zone__thumb::after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 5px 0;

  font-size: 14px;
  text-align: center;
}
.drop-zone__prompt {
  font-size: 50px;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
}

.zipPopupBack {
  position: fixed;
  width: 100%;
  height: 100%;
  display: block;
  overflow-y: hidden;
  top: 0;
  left: 0;
  background-color: rgba(black, 0.5);
  z-index: 1000000;
}
</style>